export const nl = {
	general: {
		'world': 'Hallo wereld!',
		'Y': 'Ja',
		'N': 'Nee',
	},

	gdpr: {
		title: "Privacy notice",
		client: "NV NESTLE BELGILUX",
		adress: "Birminghamstraat 221, 1070 BRUXELLES B",
	},

	footer: {
		genterms: "Algemene voorwaarden",
	},

	navigation: {
		previous: "Vorige",
		next: "Volgende",
		skipSurvey: "Cashback afronden",
		doSurvey: "Enquete deelnemen",
	},

	auth: {
		form: {
			login: 'Aanmelden',
			username: 'Gebruikersnaam',
			usernamePlaceholder: 'Geef uw gebruikersnaam in...',
			password: 'Wachtwoord',
		}
	},

	breadcrumbSteps: {
		registration: "Inschrijven ",
		store: "Doe uw aankopen",
		form: "Vul het formulier in",
		survey: "Vul een optionele vragenlijst in",
		cashback: "Ontvang uw terugbetaling"
	},

	product: {
		subtitle : "Behoud van ons immuunsysteem.",
		subsubtitle : "De bescherming die we allemaal verdienen."
	},

	header: {
		macaron : "1 + 1 terugbetaald"
	},

	pageTitles: {
		maxReached: "Maximum aantal inzendingen bereikt",
		wrongCode: "Verkeerde code",
		registration: "Schrijf u in en ontvang uw Cashback!",
		alreadySend: "Deelname reeds verstuurd",
		confirmation: "Bevestiging",
		beforeStart: "Deze actie is nog niet beschikbaar.",
		actionEnded: "Deze actie is afgelopen.",
	},

	sectionTitles: {
		inscription: "Schrijf u hier in",
	},

	pageLitteracy: {
		maxReached : "Het maximale aantal deelnames is bereikt. Deze actie is daarom niet meer toegankelijk.",
		wrongCode: "De opgegeven code is verkeerd. U moet de link gebruiken die u door Purina wordt toegestuurd. Maar misschien wil je je inschrijven voor de actie?",
		signup: "Schrijf je nu in!",
		alreadySend: "U heeft uw deelname al verzonden",
		registration : {
			byRegistering: "Door me in te schrijven voor deze actie, ga ik akkoord met de",
			privacyNotice: "Privacy notice",
			claimMail : "Inschrijven via e-mail",
			claimWhatsapp: "Inschrijven via Whatsapp",
			claimSms: "Inschrijven via SMS",
			or: "Of",
			whatsappTitle: "Klik op de Whatsapp knop",
			whatsappInfo: "Een venster wordt geopend en u wordt gevraagd om het woord PURINANL van uit uw Whatsapp te verzenden.",
		},
		confirmInscription: {
			thanks: "Bedankt voor uw inschrijving!",
			smsLine1 :"We hebben je net een SMS gestuurd met alle details.",
			smsLine2: "Ga eens kijken!",
			smsLine3: "Opgepast : Deze actie is beperkt tot 8000 deelnames. Wacht dus niet te lang om deel te nemen.",
			whatsappLine1: "Controleer uw telefoon.",
			whatsappLine2: "Alle instructies zijn verstuurd via Whatsapp",
			whatsappLine3: "Opgepast : Deze actie is beperkt tot 8000 deelnames. Wacht dus niet te lang om deel te nemen.",
			mailLine1: "We hebben je net een e-mail gestuurd met alle details.",
			mailLine2: "Ga eens kijken!",
			mailLine3: "Opgepast : Deze actie is beperkt tot 8000 deelnames. Wacht dus niet te lang om deel te nemen.",
		},
		landing: {
			mainTitle: "Ontvang uw cashback nu!",
			aboutYou: "Vertel ons meer over u",
			popTitle : "Aankoopbewijs",
			agree: "Ik aanvaard",
			termsAndConditions: "de algemene voorwaarden",
			moreInfo: `Ja, ik wil graag op de hoogte gehouden worden van het laatste nieuws en de aanbiedingen van Purina ONE en de andere merken van Nestlé. Ik aanvaard de <a href="https://www.nestle.be/nl/info/yourdata">privacyverklaring</a> van Nestlé. Ik begrijp dat ik deze toestemming op elk ogenblik kan intrekken.`,
			moreInfoHelper: "We sturen je gemiddeld elke twee maanden een e-mail",
			claimCashback: "Mijn Cashback aanvragen",
		},
		choiceSurvey: {
			title: "",
			fillSurveyIncite: "Neem deel aan onze enquete en krijg een e-coupon van 2€ voor uw volgende aankoop",
		},
		survey: {
			title: "",
			aboutCat: "Over uw kat",
		},
		confirmation: {
			title: "Bevestiging",
			textes: {
				p1: "Wij danken u voor uw deelname aan de Purina ONE actie.",
				p2: "U ontvangt uw terugbetaling binnen 24 dagen, mits u aan de algemene voorwaarden heeft voldaan.",
				p3: "Met vriendelijke groeten,",
				p4: "Het Purina ONE Team"
			},
		},
		beforeStart: {
			text: "U krijgt toegang vanaf",
		},
		actionEnded: {
			text: "Bezoek onze website regelmatig om op de hoogte te blijven van toekomstige acties.",
		},
	},






	inputLabel: {
		defaultListHelper: "Kies er één uit de lijst",
		mandatoryFields: "Verplichte velden",


		title : {
			label : "Aanspreking",
			placeholder : "Hoe kunnen we u noemen?",
			helper : "",
		},
		firstname: {
			label: "Gelieve uw voornaam in te vullen",
			placeholder : "Voornaam",
			helper: "",
		},
		lastname: {
			label: "Gelieve uw naam in te vullen",
			placeholder : "Achternaam",
			helper: "",
		},
		email : {
			label: "Gelieve uw e-mail in te vullen",
			placeholder: "dupont{'@'}exemple.be",
			helper: "Uw e-mail moet een {'@'} bevatten"
		},
		phone : {
			label: "Gelieve uw GSM-nummer in te vullen",
			placeholder: "+32123456789",
			helper: "GSM-nummer met de internationale code"
		},
		iban : {
			label: "Gelieve uw IBAN nummer te vullen",
			placeholder: "",
			helper: ""
		},
		popitem : {
			label: "Van de twee gekochte Purina ONE Cats producten, geef het goedkopere product aan",
			placeholder: "Kies er één uit de lijst",
			helper: "",
		},
		empty : {
			label: "",
			placeholder: "",
			helper: ""
		},


	  //https://vue-i18n.intlify.dev/guide/essentials/syntax.html#literal-interpolation

/*
	  typePassword : "Gelieve je wachtwoord in te vullen",
	  helpPassword : "Je wachtwoord moet X, Y en Z bevatten",
	  typeUniqueCode : "Indiquez ici le code visible sur le ticket de caisse",
	  */

	  upload: {
	  	state: "status",
	  	uploadYourFile: "Upload bestand",
	  	clickOrDrop: "Klik of sleep je ticket hier.",
	  	remove: "Verwijder",
	  	waiting: "Wachten op upload...",
	  	uploaded: "Geüpload!",
	  	error: "Mislukt",
	  	uploadsDone: "Upload succesvol afgerond",
	  	onlyImages: "Enkel afbeeldingen of PDFs worden aanvaard. ",
	  	maxSize: "Maximale grootte van 20mb",
	  	uploadFile: "Upload bestand",
	  	generalError: "Er ging iets mis met uw upload, gelieve later opnieuw te proberen",
	  	emptyFile: "U moet een bestand sturen",
	  }
	},

	temporary: {
		surveyQ417 : {
			label : "Geboortedatum van uw kat?",
			placeholder: "",
			helper: ""
		},
		surveyQ418: {
			label: "Geeft u uw kat gewoonlijk op dezelfde dag droog- en natvoer?",
			placeholder: "Kies een antwoord",
			helper: ""
		},
		surveyQ419: {
			label: "Zo niet, is het voornamelijk droog- of natvoer?",
			placeholder: "Kies een antwoord",
			helper: "",
		},
		surveyQ420: {
			label: "Geeft u uw kat voornamelijk Purina ONE droog kattenvoer?",
			placeholder: "Kies een antwoord",
			helper: ""
		},
		surveyQ421: {
			label: "Zo nee, welk(e) merk(en) geeft u voornamelijk?",
			placeholder: "",
			helper: "",
		},
		surveyQ422: {
			label: "Geeft u uw kat voornamelijk Purina ONE nat kattenvoer?",
			placeholder: "Kies een antwoord",
			helper: ""
		},
		surveyQ423: {
			label: "Zo nee, welk(e) merk(en) geeft u dan voornamelijk?",
			placeholder: "",
			helper: "",
		},
		surveyQ424 : {
			label : "Wat is de naam van uw kat?",
			placeholder: "",
			helper: ""
		},
	},

	validations: {
		dateInvalid: "Ongeldige datum.",
		dateBefore: "Gelieve een datum voor vandaag in te geven."
	}

}
